import axios from "axios";

/**
 * Upload a file to the new restaurant endpoint
 * @param file - The file to upload
 * @param type - The type of file (default: "image")
 * @returns Promise<string> - The URL of the uploaded file
 */
export const uploadFile = async (
  file: File,
  type: string = "image"
): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);

  try {
    const response = await axios.post(
      "https://api.foodbank4u.com/api/restaurant/upload/file",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data.url;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

/**
 * Upload an image file (convenience function)
 * @param file - The image file to upload
 * @returns Promise<string> - The URL of the uploaded image
 */
export const uploadImage = async (file: File): Promise<string> => {
  return uploadFile(file, "image");
};
